export { default as ForgetPassword } from './ForgetPassword';
